export const iconFontAwesomeBuildingsTentArrowTurnLeft = (
	<i className="fa-solid fa-tent-arrow-turn-left"></i>
);
